import { motion, useAnimation, AnimatePresence } from 'framer-motion';
import { graphql, useStaticQuery } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

// import Link from 'components/shared/link';

import useStoryblok from '../../../lib/storyblok';

const ANIMATION_DURATION = 0.5;

const variants = {
  from: {
    opacity: 0,
    translateY: '50vh',
    transition: {
      type: 'tween',
      duration: ANIMATION_DURATION,
      when: 'afterChildren',
      staggerChildren: 0,
      staggerDirection: -1,
      delay: 0.1,
    },
    transitionEnd: {
      zIndex: -1,
    },
  },
  to: {
    zIndex: 999,
    opacity: 0.85,
    translateY: 0,
    transition: {
      type: 'tween',
      duration: ANIMATION_DURATION,
      when: 'beforeChildren',
      staggerChildren: 0.1,
    },
    transitionEnd: {
      zIndex: 999,
    },
  },
};

const childrenVariants = {
  from: {
    opacity: 0,
    y: 5,
  },
  to: {
    opacity: 1,
    y: 0,
  },
};

const MobileMenu = ({ isOpen, setIsOpen }) => {
  const controls = useAnimation();

  function transformMenu(data) {
    return data.content.items.map((item) => {
      const menuItem = {
        text: item.title,
        to: `/${item.link.cached_url}`,
      };

      if (item.sub_menu && item.sub_menu.length > 0) {
        menuItem.submenu = item.sub_menu.map((subItem) => ({
          text: subItem.title,
          to: `/${subItem.link.cached_url}`,
        }));
      }

      return menuItem;
    });
  }

  const onMenuClick = () => {
    setIsOpen(false);
  };

  const data = useStaticQuery(graphql`
    query NavQuery {
      storyblokEntry(full_slug: { eq: "header" }) {
        id
        content
      }
    }
  `);

  useEffect(() => {
    if (isOpen) {
      controls.start('to');
    } else {
      controls.start('from');
    }
  }, [isOpen, controls]);

  const entry = useStoryblok(data.storyblokEntry);

  const menuLinks = transformMenu(entry);

  return (
    <AnimatePresence mode="wait" onExitComplete={() => setIsOpen(false)}>
      {isOpen && (
        <motion.nav
          className="container fixed inset-0 top-[4.5rem] z-[-1] block bg-primary py-14 lg:hidden"
          initial="from"
          exit="from"
          animate={controls}
          variants={variants}
        >
          <motion.ul className="flex h-full flex-col gap-6">
            {menuLinks?.map(({ text, to, styles }, index) => {
              const linkStyles = `inline-block text-[1.375rem] font-bold uppercase font-heading ${
                styles || ''
              }`;
              return (
                <motion.li key={index} variants={childrenVariants}>
                  <AniLink
                    className={linkStyles}
                    to={to}
                    direction="up"
                    bg="#000000"
                    duration={1}
                    cover
                    onClick={onMenuClick}
                  >
                    {text}
                  </AniLink>
                </motion.li>
              );
            })}
          </motion.ul>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
};

MobileMenu.defaultProps = {
  isOpen: false,
};

export default MobileMenu;
